<template>
  <v-container class="mt-4 ml-2 pr-6" fluid>
    <template v-if="puedeGestionarBecasEmpleados">
      <!-- Card filtros -->
      <v-card class="shadowCard mb-3 becas-filtros-card">
        <v-card-title class="becas-filtros-titulo pt-4 pb-0 px-4">
          <v-icon small color="primary" class="mr-2">mdi-filter-variant</v-icon>
          <span class="text-subtitle-1 font-weight-medium">Filtros</span>
          <v-chip
            v-if="cantidadFiltrosActivos > 0"
            x-small
            color="primary"
            outlined
            class="ml-2"
          >
            {{ cantidadFiltrosActivos }} activo{{ cantidadFiltrosActivos > 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-btn
            v-if="cantidadFiltrosActivos > 0"
            text
            small
            color="primary"
            class="mr-n2"
            @click="limpiarFiltros"
          >
            <v-icon left small>mdi-filter-off-outline</v-icon>
            Limpiar
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="becas-filtros-ayuda px-4 pt-2 pb-0 text-caption grey--text text--darken-1">
          Busca por trabajador, beneficiario, matrícula o fecha de alta
        </v-card-subtitle>
        <v-card-text class="becas-filtros-campos px-4 pt-4 pb-4">
          <v-row dense class="mb-3">
            <v-col cols="12" sm="6" lg="4">
              <v-text-field
                v-model="filtros.buscar"
                label="Buscar"
                placeholder="Trabajador, beneficiario o matrícula"
                filled
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
              />
            </v-col>
            <v-col cols="6" sm="4" lg="2">
              <v-select
                v-model="filtros.tipo"
                :items="opcionesTipo"
                label="Tipo"
                filled
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="6" sm="4" lg="2">
              <v-select
                v-model="filtros.vigencia"
                :items="opcionesVigencia"
                label="Vigencia"
                filled
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="6" sm="4" lg="2">
              <v-menu
                v-model="menuFechaFiltro"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaFiltroTexto"
                    label="Fecha alta"
                    filled
                    dense
                    hide-details
                    readonly
                    clearable
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @click:clear.stop="limpiarFechaFiltro"
                  />
                </template>
                <v-date-picker
                  v-model="filtros.fecha"
                  no-title
                  scrollable
                  @input="menuFechaFiltro = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols="6" sm="4" lg="2">
              <v-select
                v-model="filtros.origen"
                :items="opcionesOrigen"
                label="Origen"
                filled
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="6" sm="4" lg="3">
              <v-autocomplete
                v-model="filtros.id_ciclo"
                :items="opcionesCiclo"
                label="Ciclo"
                placeholder="Buscar ciclo"
                filled
                dense
                hide-details
                clearable
                item-text="text"
                item-value="value"
                no-data-text="Sin coincidencias"
              />
            </v-col>
            <v-col cols="6" sm="4" lg="2">
              <v-select
                v-model="filtros.trabajador_activo"
                :items="opcionesTrabajadorActivo"
                label="Trabajador"
                filled
                dense
                hide-details
                clearable
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="pt-1">
              <v-checkbox
                v-model="incluirInscripciones"
                dense
                hide-details
                class="mt-0 mb-0"
                label="Incluir alumnos ligados en inscripciones que aún no tienen solicitud RH"
                @change="getBecas"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Card tabla -->
      <v-card class="shadowCard" style="padding: 1rem;">
        <v-card-title class="pb-2">
          <v-row align="center" justify="space-between" class="ma-0" style="width: 100%;">
            <h2 class="mb-0">Becas empleados</h2>
            <div class="d-flex align-center flex-wrap">
              <v-btn
                color="green"
                dark
                small
                tile
                class="mr-2"
                :disabled="!becasFiltradas.length || loading"
                @click="descargarExcel"
              >
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Excel
              </v-btn>
              <v-btn
                color="primary"
                outlined
                small
                tile
                class="mr-2"
                :loading="loading"
                @click="actualizarInformacion"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
              <v-btn
                color="primary"
                small
                tile
                @click="abrirModalAlta"
              >
                Solicitar
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="orange"
                    dark
                    small
                    tile
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left small>mdi-school</v-icon>
                    Inscribir colaborador
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="abrirInscripcion(1)">
                    <v-list-item-title>Inscribir en INBI</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="abrirInscripcion(2)">
                    <v-list-item-title>Inscribir en FAST</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </v-card-title>
        <v-card-text class="pt-0">
          <div class="tabla-becas-empleados">
          <v-data-table
            :headers="headers"
            :items="becasFiltradas"
            :loading="loading"
            dense
            elevation-0
            :item-key="rowKeyBeca"
          >
            <template v-slot:top>
              <div class="text-caption grey--text text-right pb-1">
                {{ becasFiltradas.length }} de {{ becas.length }} registros
              </div>
            </template>

            <template v-slot:item.activo_sn="{ item }">
              <div>
                <v-chip
                  v-if="item.origen === 'inscripciones'"
                  small
                  outlined
                  color="orange"
                >
                  Sin solicitud RH
                </v-chip>
                <v-chip
                  v-else
                  small
                  :color="Number(item.activo_sn) === 1 ? 'green' : 'grey'"
                  dark
                >
                  {{ Number(item.activo_sn) === 1 ? 'Activa' : 'Inactiva' }}
                </v-chip>
                <div
                  v-if="item.origen !== 'inscripciones' && Number(item.activo_sn) !== 1 && item.fecha_baja"
                  class="caption grey--text"
                >
                  {{ formatearFecha(item.fecha_baja) }}
                </div>
                <div
                  v-if="item.origen !== 'inscripciones' && Number(item.activo_sn) !== 1 && Number(item.trabajador_activo_sn) !== 1"
                  class="caption orange--text text--darken-2"
                >
                  Baja laboral ERP
                </div>
              </div>
            </template>

            <template v-slot:item.id="{ item }">
              <span v-if="item.id">{{ item.id }}</span>
              <v-chip v-else x-small outlined color="orange">INS</v-chip>
            </template>

            <template v-slot:item.folio_rh="{ item }">
              <v-chip
                v-if="item.folio_rh"
                small
                color="primary"
                outlined
              >
                {{ item.folio_rh }}
              </v-chip>
              <span v-else class="grey--text">—</span>
            </template>

            <template v-slot:item.trabajador="{ item }">
              <div>
                <span>{{ item.trabajador || '—' }}</span>
                <v-chip
                  v-if="Number(item.trabajador_activo_sn) !== 1"
                  x-small
                  color="grey"
                  dark
                  class="ml-1"
                >
                  Baja laboral
                </v-chip>
              </div>
            </template>

            <template v-slot:item.tipoBeneficiario="{ item }">
              <v-chip
                small
                :color="esFamiliarInscripciones(item) ? 'blue' : 'teal'"
                dark
              >
                {{ esFamiliarInscripciones(item) ? 'Familiar' : 'Propio' }}
              </v-chip>
            </template>

            <template v-slot:item.esFamiliar="{ item }">
              <v-chip
                small
                :color="esFamiliarInscripciones(item) ? 'blue' : 'grey'"
                dark
                @click="abrirFamiliar(item)"
                style="cursor:pointer"
              >
                {{ esFamiliarInscripciones(item) ? 'Sí' : 'No' }}
              </v-chip>
            </template>

            <template v-slot:item.parentesco="{ item }">
              <span>{{ item.parentesco || '—' }}</span>
            </template>

            <template v-slot:item.matricula_vigente_sn="{ item }">
              <v-chip
                small
                :color="Number(item.matricula_vigente_sn) === 1 ? 'green' : 'orange'"
                :outlined="Number(item.matricula_vigente_sn) !== 1"
                dark
              >
                {{ Number(item.matricula_vigente_sn) === 1 ? 'Vigente' : 'No vigente' }}
              </v-chip>
            </template>

            <template v-slot:item.ciclos_alumno="{ item }">
              <span>{{ item.ciclos_alumno || '—' }}</span>
            </template>

            <template v-slot:item.ultimo_grupo="{ item }">
              <span>{{ item.ultimo_grupo || '—' }}</span>
            </template>

            <template v-slot:item.alumno="{ item }">
              <span>{{ item.alumno || item.nombre || '—' }}</span>
            </template>

            <template v-slot:item.acta_nacimiento="{ item }">
              <v-chip
                small
                color="purple"
                dark
                @click="abrirFamiliar(item)"
                style="cursor:pointer"
              >
                {{ getExtension(item.acta_nacimiento) }}
              </v-chip>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn
                v-if="item.id"
                icon
                small
                title="Editar"
                @click="abrirModalEditar(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                small
                color="primary"
                title="Solicitar beca RH"
                @click="abrirSolicitudDesdeVinculo(item)"
              >
                <v-icon small>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          </div>
        </v-card-text>
      </v-card>

      <!-- Modal alta / edición -->
      <v-dialog v-model="dialog" max-width="560" persistent scrollable>
        <v-card>
          <v-card-title class="pt-5 pb-3">
            <div class="d-flex align-start">
              <v-icon color="primary" class="mr-3 mt-1">
                {{ modoEdicion ? 'mdi-pencil' : 'mdi-school' }}
              </v-icon>
              <div>
                <div class="text-h6 font-weight-medium line-height-tight">
                  {{ modoEdicion ? 'Editar beca' : 'Solicitar beca' }}
                </div>
                <div class="text-body-2 grey--text text--darken-1 mt-2 mb-1">
                  {{ modoEdicion ? 'Consulta o actualiza la autorización RH del trabajador' : 'Genera el folio RH para el empleado o un familiar' }}
                </div>
              </div>
            </div>
          </v-card-title>

          <v-divider />

          <v-card-text class="pt-4">
            <v-alert
              v-if="alertaFamiliares.length"
              type="warning"
              dense
              outlined
              class="mb-4"
            >
              <div class="text-body-2 font-weight-medium mb-1">Becas de familiares ya registradas</div>
              <ul class="mb-0 pl-4 caption">
                <li v-for="f in alertaFamiliares" :key="f.id">
                  {{ f.nombre || 'Sin nombre' }}
                  <span v-if="f.parentesco"> ({{ f.parentesco }})</span>
                  <span v-if="f.folio_rh"> — {{ f.folio_rh }}</span>
                </li>
              </ul>
            </v-alert>

            <div class="text-overline grey--text text--darken-1 mb-2">Trabajador</div>
            <v-autocomplete
              v-model="form.id_trabajador"
              :items="trabajadoresActivos"
              item-text="nombre_completo"
              item-value="id"
              label="Selecciona el trabajador"
              filled
              dense
              hide-details
              clearable
              class="mb-4"
              :disabled="guardando || modoEdicion"
              @change="onCambioTrabajador"
            />

            <div v-if="form.folio_rh" class="mb-4">
              <div class="text-overline grey--text text--darken-1 mb-2">Folio RH</div>
              <v-chip color="primary" outlined class="px-3">
                <v-icon left small>mdi-ticket-confirmation-outline</v-icon>
                {{ form.folio_rh }}
              </v-chip>
              <div class="caption grey--text mt-1">
                Este folio se usa en Inscripciones para aplicar la beca 100%.
              </div>
            </div>
            <v-alert
              v-else-if="modoEdicion"
              type="info"
              dense
              outlined
              class="mb-4"
            >
              Este registro aún no tiene folio RH. Al guardar se generará uno.
            </v-alert>

            <div class="text-overline grey--text text--darken-1 mb-2">Beneficiario de la beca</div>
            <v-radio-group
              v-model="tipoBeneficiario"
              row
              dense
              hide-details
              class="mt-0 mb-3"
              :disabled="guardando || !form.id_trabajador"
              @change="onCambioTipoBeneficiarioRadio"
            >
              <v-radio label="El propio empleado" value="empleado" />
              <v-radio label="Un familiar" value="familiar" />
            </v-radio-group>

            <v-expand-transition>
              <div v-if="form.esFamiliar" class="mb-3">
                <div class="text-overline grey--text text--darken-1 mb-2">Datos del familiar</div>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.nombre"
                      label="Nombre del familiar *"
                      filled
                      dense
                      hide-details="auto"
                      :disabled="guardando"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.edad"
                      label="Edad"
                      type="number"
                      filled
                      dense
                      hide-details
                      :disabled="guardando"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.parentesco"
                      label="Parentesco *"
                      hint="Hijo, hija, cónyuge, etc."
                      persistent-hint
                      filled
                      dense
                      hide-details="auto"
                      :disabled="guardando"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>

            <v-expansion-panels flat class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-0 py-2">
                  <span class="text-body-2 grey--text text--darken-1">Documentación (opcional)</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-file-input
                    v-model="form.archivo"
                    label="Acta de nacimiento"
                    accept=".pdf,image/*"
                    filled
                    dense
                    hide-details
                    prepend-icon="mdi-file-upload"
                    clearable
                    :disabled="guardando"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text :disabled="guardando" @click="cerrarModal">Cancelar</v-btn>
            <v-btn
              color="primary"
              small
              tile
              :loading="guardando"
              :disabled="!puedeGuardarForm"
              @click="guardar"
            >
              {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFamiliar" max-width="600">
        <v-card>
          <v-card-title>Detalle de la beca</v-card-title>
          <v-card-text>
            <p><b>Trabajador:</b> {{ familiar.trabajador }}</p>
            <p v-if="familiar.folio_rh"><b>Folio RH:</b> {{ familiar.folio_rh }}</p>
            <p><b>Familiar:</b> {{ familiar.esFamiliar ? 'Sí' : 'No' }}</p>
            <p v-if="familiar.esFamiliar"><b>Nombre:</b> {{ familiar.nombre }}</p>
            <p v-if="familiar.esFamiliar"><b>Edad:</b> {{ familiar.edad }}</p>
            <p v-if="familiar.esFamiliar"><b>Parentesco:</b> {{ familiar.parentesco }}</p>
            <p><b>Alumno:</b> {{ familiar.alumno || '—' }}</p>
            <p><b>Matrícula:</b> {{ familiar.matricula || '—' }}</p>

            <div v-if="archivoPreview" style="width: auto; height: 500px;">
              <iframe
                :src="archivoPreview"
                width="100%"
                height="100%"
              ></iframe>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEstado" max-width="400">
        <v-card>
          <v-card-title>Cambiar estado</v-card-title>
          <v-card-text>
            <v-select
              v-model="estadoSeleccionado"
              :items="estados"
              label="Estado"
              dense
              filled
              hide-details
            />

            <v-textarea
              v-if="estadoSeleccionado === 2"
              v-model="motivoRechazo"
              label="Motivo del rechazo"
              filled
              dense
              class="mt-3"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="dialogEstado=false">Cancelar</v-btn>
            <v-btn color="primary" small tile @click="guardarEstado">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <dialogSteppers
        v-if="dialogAddAlumno.estatus"
        :dialogAddAlumno="dialogAddAlumno"
      />
    </template>

    <v-card v-else class="shadowCard pa-6">
      <div class="text-subtitle-1">Acceso restringido</div>
      <div class="text-body-2 grey--text mt-2">
        No tienes permiso para gestionar becas de empleados.
      </div>
    </v-card>
  </v-container>
</template>

<script>
import XLSX from 'xlsx'
import { mapGetters, mapActions } from 'vuex'
import validarErrores from '@/mixins/validarErrores'
import dialogSteppers from '@/components/inscripciones/steppers/dialogSteppers.vue'

/** RH autorizado */
const IDERPS_BECAS_EMPLEADOS = [966]
/** JEFE DE TI + DESARROLLADOR DE SOFTWARE (Sistemas TI) */
const IDPUESTOS_BECAS_EMPLEADOS = [11, 12]

export default {
  name: 'BecasEmpleados',

  components: { dialogSteppers },

  mixins: [validarErrores],

  data() {
    return {
      dialog: false,
      modoEdicion: false,
      becaEditId: null,
      loading: false,
      guardando: false,

      becas: [],
      trabajadores: [],
      ciclos: [],
      menuFechaFiltro: false,

      incluirInscripciones: true,

      filtros: {
        buscar: '',
        tipo: null,
        vigencia: null,
        fecha: null,
        origen: null,
        id_ciclo: null,
        trabajador_activo: null
      },

      opcionesTipo: [
        { text: 'Empleado (propio)', value: 0 },
        { text: 'Familiar', value: 1 }
      ],
      opcionesOrigen: [
        { text: 'Solicitud RH', value: 'rh' },
        { text: 'Solo inscripciones', value: 'inscripciones' }
      ],
      opcionesVigencia: [
        { text: 'Activa', value: 1 },
        { text: 'Inactiva', value: 0 }
      ],

      opcionesTrabajadorActivo: [
        { text: 'Activo', value: 1 },
        { text: 'Inactivo', value: 0 }
      ],

      dialogFamiliar: false,
      archivoPreview: null,
      familiar: {},

      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Folio RH', value: 'folio_rh' },
        { text: 'Trabajador', value: 'trabajador' },
        { text: 'Tipo', value: 'tipoBeneficiario' },
        { text: 'Beneficiario', value: 'alumno' },
        { text: 'Parentesco', value: 'parentesco' },
        { text: 'Matrícula', value: 'matricula' },
        { text: 'Matr. acad.', value: 'matricula_vigente_sn' },
        { text: 'Ciclo', value: 'ciclos_alumno' },
        { text: 'Último grupo', value: 'ultimo_grupo' },
        { text: 'Documento', value: 'acta_nacimiento' },
        { text: 'Vigencia RH', value: 'activo_sn' },
        { text: 'Fecha alta', value: 'fecha_alta' },
        { text: 'Acciones', value: 'acciones', sortable: false }
      ],

      form: this.formVacio(),

      alumnoSeleccionado: null,
      alumnosBusqueda: [],
      loadingAlumnos: false,
      _debounceAlumnos: null,
      _bloquearBusquedaAlumno: false,
      alertaFamiliares: [],
      sinMatriculaEmpleado: false,
      sugeridosEmpleado: [],
      alumnosFamiliaresVinculados: [],
      familiaresMatriculaVigente: [],
      sinFamiliaresVigentes: false,
      tipoBeneficiario: 'empleado',

      dialogEstado: false,
      estadoSeleccionado: null,
      motivoRechazo: null,
      becaSeleccionada: null,

      dialogAddAlumno: { estatus: false },
      escuelaOriginal: null,

      estados: [
        { text: 'Pendiente', value: 0 },
        { text: 'Aprobado', value: 1 },
        { text: 'Rechazado', value: 2 }
      ]
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP', 'getEscuela']),

    puedeGestionarBecasEmpleados() {
      const u = this.getdatosUsuarioERPERP
      if (!u) return false
      if (u.iderp != null && IDERPS_BECAS_EMPLEADOS.includes(Number(u.iderp))) {
        return true
      }
      if (u.idpuesto != null && IDPUESTOS_BECAS_EMPLEADOS.includes(Number(u.idpuesto))) {
        return true
      }
      return false
    },

    hintAlumno() {
      if (!this.form.esFamiliar) {
        if (this.sinMatriculaEmpleado) {
          return 'Este trabajador no tiene matrícula propia registrada en el sistema'
        }
        if (this.form.matricula) {
          return 'Matrícula del trabajador: ' + this.form.matricula
        }
        return 'Se liga automáticamente a la matrícula del trabajador'
      }
      if (this.form.id_alumno && this.form.matricula) {
        return 'Matrícula: ' + this.form.matricula
      }
      if (this.sinFamiliaresVigentes) {
        return 'No hay familiares con matrícula vigente (alumno activo y grupo activo)'
      }
      const n = (this.familiaresMatriculaVigente || []).length
      if (n === 1) {
        return 'Selecciona el familiar vinculado al trabajador'
      }
      return 'Selecciona el familiar (' + n + ' con matrícula vigente)'
    },

    fechaFiltroTexto() {
      if (!this.filtros.fecha) return ''
      const p = String(this.filtros.fecha).split('-')
      if (p.length !== 3) return this.filtros.fecha
      return p[2] + '/' + p[1] + '/' + p[0]
    },

    opcionesCiclo() {
      const lista = [...(this.ciclos || [])]
      lista.sort((a, b) => {
        const ta = a.fecha_inicio_ciclo ? new Date(a.fecha_inicio_ciclo).getTime() : 0
        const tb = b.fecha_inicio_ciclo ? new Date(b.fecha_inicio_ciclo).getTime() : 0
        if (tb !== ta) return tb - ta
        return String(a.ciclo || '').localeCompare(String(b.ciclo || ''), 'es')
      })
      return lista.map((c) => ({
        text: c.ciclo,
        value: c.id_ciclo
      }))
    },

    becasFiltradas() {
      const lista = this.becas || []
      const buscar = (this.filtros.buscar || '').trim().toLowerCase()
      const fechaFiltro = this.filtros.fecha

      return lista.filter((item) => {
        const esFam = this.esFamiliarInscripciones(item)
        if (this.filtros.tipo !== null && this.filtros.tipo !== '' && Number(esFam) !== Number(this.filtros.tipo)) {
          return false
        }
        if (this.filtros.origen && item.origen !== this.filtros.origen) {
          return false
        }
        if (this.filtros.vigencia !== null && this.filtros.vigencia !== '') {
          if (item.origen === 'inscripciones') return false
          if (Number(item.activo_sn) !== Number(this.filtros.vigencia)) return false
        }
        if (fechaFiltro && !this.fechaAltaCoincide(item.fecha_alta, fechaFiltro)) {
          return false
        }
        if (this.filtros.id_ciclo != null && this.filtros.id_ciclo !== '') {
          if (!this.alumnoEnCiclo(item, this.filtros.id_ciclo)) return false
        }
        if (this.filtros.trabajador_activo !== null && this.filtros.trabajador_activo !== '') {
          if (Number(item.trabajador_activo_sn) !== Number(this.filtros.trabajador_activo)) return false
        }
        if (buscar) {
          const texto = [
            item.folio_rh,
            item.trabajador,
            item.alumno,
            item.nombre,
            item.matricula
          ].filter(Boolean).join(' ').toLowerCase()
          if (texto.indexOf(buscar) === -1) return false
        }
        return true
      })
    },

    cantidadFiltrosActivos() {
      let n = 0
      if ((this.filtros.buscar || '').trim()) n++
      if (this.filtros.tipo !== null && this.filtros.tipo !== '') n++
      if (this.filtros.vigencia !== null && this.filtros.vigencia !== '') n++
      if (this.filtros.fecha) n++
      if (this.filtros.origen) n++
      if (this.filtros.id_ciclo != null && this.filtros.id_ciclo !== '') n++
      if (this.filtros.trabajador_activo !== null && this.filtros.trabajador_activo !== '') n++
      return n
    },

    puedeGuardarForm() {
      if (!this.form.id_trabajador) return false
      if (this.form.esFamiliar) {
        return !!(this.form.nombre && this.form.parentesco)
      }
      return true
    },

    alumnoSelectSoloLectura() {
      if (!this.form.esFamiliar) {
        return (this.sugeridosEmpleado || []).length <= 1
      }
      return !this.sinFamiliaresVigentes && (this.familiaresMatriculaVigente || []).length <= 1
    },

    trabajadoresActivos() {
      return (this.trabajadores || []).filter((t) => Number(t.activo_sn) === 1)
    },

    listaAlumnosAutocomplete() {
      if (!this.form.esFamiliar) {
        return this.sugeridosEmpleado || []
      }
      return this.familiaresMatriculaVigente || []
    }
  },

  watch: {
    alumnoSeleccionado(val) {
      if (val && typeof val === 'object') {
        this.form.id_alumno = val.id_alumno
        this.form.matricula = val.matricula
        if (!this.form.esFamiliar) {
          const ok = (this.sugeridosEmpleado || []).some(
            (s) => Number(s.id_alumno) === Number(val.id_alumno)
          )
          this.sinMatriculaEmpleado = !ok
        } else {
          this.sinMatriculaEmpleado = false
          const idAnterior = Number(this._idAlumnoFamiliarPrev || 0)
          const idNuevo = Number(val.id_alumno)
          if (idAnterior && idAnterior !== idNuevo) {
            this.form.parentesco = null
          }
          this._idAlumnoFamiliarPrev = idNuevo
          this.aplicarDatosDesdeAlumno(val)
        }
        this.alumnosBusqueda = this.incluirAlumnoEnLista(this.alumnosBusqueda, val)
      } else if (!val) {
        this.form.id_alumno = null
        this.form.matricula = null
        if (this.form.esFamiliar) {
          this.form.nombre = null
          this.form.edad = null
          this.form.parentesco = null
          this._idAlumnoFamiliarPrev = null
        }
        if (!this.form.esFamiliar) {
          this.sinMatriculaEmpleado = !(this.sugeridosEmpleado || []).length
        }
      }
    },

    'dialogAddAlumno.estatus'(val) {
      if (val) return
      if (this.escuelaOriginal) {
        this.cambiarEscuela(this.escuelaOriginal)
        this.escuelaOriginal = null
      }
      this.cargarTodo()
    }
  },

  mounted() {
    if (this.puedeGestionarBecasEmpleados) {
      this.cargarTodo()
    }
  },

  methods: {
    formVacio() {
      return {
        id_trabajador: null,
        archivo: null,
        aplicado: 0,
        esFamiliar: false,
        nombre: null,
        edad: null,
        parentesco: null,
        id_alumno: null,
        matricula: null,
        folio_rh: null,
        id_autorizacion: null
      }
    },

    folioDesdeAutorizacion(idAutorizacion) {
      const n = Number(idAutorizacion)
      if (!Number.isFinite(n) || n <= 0) return null
      return 'RH-' + String(n).padStart(5, '0')
    },

    abrirModalAlta() {
      this.modoEdicion = false
      this.becaEditId = null
      this.resetForm()
      this.dialog = true
    },

    limpiarFiltros() {
      this.filtros = {
        buscar: '',
        tipo: null,
        vigencia: null,
        fecha: null,
        origen: null,
        id_ciclo: null,
        trabajador_activo: null
      }
    },

    limpiarFechaFiltro() {
      this.filtros.fecha = null
    },

    abrirModalEditar(item) {
      this.modoEdicion = true
      this.becaEditId = item.id
      this.tipoBeneficiario = Number(item.esFamiliar) ? 'familiar' : 'empleado'
      const folio = item.folio_rh || this.folioDesdeAutorizacion(item.id_autorizacion)
      this.form = {
        id_trabajador: item.id_trabajador,
        archivo: null,
        aplicado: item.aplicado || 0,
        esFamiliar: !!Number(item.esFamiliar),
        nombre: item.nombre || item.alumno || null,
        edad: item.edad || null,
        parentesco: item.parentesco || null,
        id_alumno: item.id_alumno || null,
        matricula: item.matricula || null,
        folio_rh: folio,
        id_autorizacion: item.id_autorizacion || null
      }
      this.alertaFamiliares = []
      this.sinMatriculaEmpleado = false
      this.sugeridosEmpleado = []
      this.alumnoSeleccionado = null
      this.alumnosBusqueda = []
      this.dialog = true
      this.cargarAlertaFamiliares(item.id_trabajador)
    },

    cerrarModal() {
      this.dialog = false
      this.resetForm()
    },

    async cargarTodo() {
      this.loading = true
      await Promise.all([
        this.getBecas(),
        this.getTrabajadores(),
        this.getCiclos()
      ])
      this.loading = false
    },

    ...mapActions('login', ['cambiarEscuela']),

    async actualizarInformacion() {
      await this.cargarTodo()
      this.validarSuccess('Información actualizada')
    },

    abrirInscripcion(escuela) {
      this.escuelaOriginal = this.getEscuela
      this.cambiarEscuela(escuela)
      this.dialogAddAlumno.estatus = true
    },

    descargarExcel() {
      const filas = (this.becasFiltradas || []).map((item) => {
        const esInscripciones = item.origen === 'inscripciones'
        return {
          ID: item.id || 'INS',
          'Folio RH': item.folio_rh || '',
          Trabajador: item.trabajador || '',
          'Trabajador activo': Number(item.trabajador_activo_sn) === 1 ? 'Sí' : 'No',
          Tipo: this.esFamiliarInscripciones(item) ? 'Familiar' : 'Propio',
          Beneficiario: item.alumno || item.nombre || '',
          Parentesco: item.parentesco || '',
          Matrícula: item.matricula || '',
          'Matr. académica': Number(item.matricula_vigente_sn) === 1 ? 'Vigente' : 'No vigente',
          Ciclo: item.ciclos_alumno || '',
          'Último grupo': item.ultimo_grupo || '',
          Documento: item.acta_nacimiento ? this.getExtension(item.acta_nacimiento) : 'N/A',
          'Vigencia RH': esInscripciones
            ? 'Sin solicitud RH'
            : (Number(item.activo_sn) === 1 ? 'Activa' : 'Inactiva'),
          'Fecha alta': this.formatearFecha(item.fecha_alta),
          'Fecha baja': this.formatearFecha(item.fecha_baja),
          'Motivo rechazo': item.motivo_rechazo || '',
          Origen: esInscripciones ? 'Inscripciones' : 'Solicitud RH'
        }
      })

      if (!filas.length) {
        return this.validarError('No hay registros para exportar')
      }

      const hoja = XLSX.utils.json_to_sheet(filas)
      const libro = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(libro, hoja, 'Becas empleados')
      const fecha = new Date().toISOString().slice(0, 10)
      XLSX.writeFile(libro, 'becas_empleados_' + fecha + '.xlsx')
    },

    async getBecas() {
      try {
        const { data } = await this.$http.get('becas.trabajador.get', {
          params: {
            incluir_inscripciones: this.incluirInscripciones ? 1 : 0
          }
        })
        this.becas = data
      } catch (error) {
        this.validarError(this.msgHttp(error, 'Error al consultar becas'))
      }
    },

    async getTrabajadores() {
      this.trabajadores = []
      try {
        const response = await this.$http.get('trabajadores.erp.get.trabajadoreserp', {
          params: { activos: 'Activos' }
        })
        const rows = Array.isArray(response.data) ? response.data : []
        this.trabajadores = rows
          .filter((t) => Number(t.activo_sn) === 1)
          .map((t) => ({
            ...t,
            id: t.id_trabajador || t.id
          }))
      } catch (error) {
        this.validarError(this.msgHttp(error, 'Error al consultar trabajadores'))
      }
    },

    async getCiclos() {
      try {
        const { data } = await this.$http.get('ciclos.activos.erp')
        this.ciclos = Array.isArray(data) ? data : []
      } catch (error) {
        this.ciclos = []
        this.validarError(this.msgHttp(error, 'Error al consultar ciclos'))
      }
    },

    alumnoEnCiclo(item, idCiclo) {
      if (idCiclo == null || idCiclo === '') return true
      const ids = String(item.id_ciclos_alumno || '')
        .split(',')
        .filter(Boolean)
        .map((id) => Number(id))
      return ids.indexOf(Number(idCiclo)) !== -1
    },

    fechaAltaCoincide(fechaAlta, fechaFiltro) {
      if (!fechaAlta || !fechaFiltro) return false
      const diaAlta = String(fechaAlta).substr(0, 10)
      return diaAlta === String(fechaFiltro)
    },

    async onCambioTrabajador() {
      this.alertaFamiliares = []
      this.sinMatriculaEmpleado = false
      this.sugeridosEmpleado = []
      this.alumnosFamiliaresVinculados = []
      this.familiaresMatriculaVigente = []
      this.sinFamiliaresVigentes = false
      this.alumnoSeleccionado = null
      this.form.id_alumno = null
      this.form.matricula = null
      this.form.nombre = null
      this.form.edad = null
      this.form.parentesco = null
      this.form.archivo = null
      this.alumnosBusqueda = []
      if (!this.form.id_trabajador) return

      await Promise.all([
        this.cargarAlertaFamiliares(this.form.id_trabajador),
        this.cargarFamiliaresVinculados(this.form.id_trabajador),
        !this.form.esFamiliar
          ? this.cargarSugeridoEmpleado(this.form.id_trabajador)
          : this.cargarFamiliaresParaSelect()
      ])
    },

    async onCambioTipoBeneficiario() {
      this.sinMatriculaEmpleado = false
      if (!this.form.esFamiliar) {
        this.form.nombre = null
        this.form.edad = null
        this.form.parentesco = null
        this.alumnosBusqueda = []
        if (this.form.id_trabajador) {
          await this.cargarSugeridoEmpleado(this.form.id_trabajador)
        }
      } else {
        this.alumnoSeleccionado = null
        this.form.id_alumno = null
        this.form.matricula = null
        this.alumnosBusqueda = []
        this.sugeridosEmpleado = []
        if (this.form.id_trabajador) {
          await this.cargarFamiliaresParaSelect()
        }
      }
    },

    onCambioTipoBeneficiarioRadio() {
      this.form.esFamiliar = this.tipoBeneficiario === 'familiar'
      this.onCambioTipoBeneficiario()
    },

    async cargarAlertaFamiliares(idTrabajador) {
      try {
        const { data } = await this.$http.get('becas.trabajador.familiares/' + idTrabajador)
        let lista = Array.isArray(data) ? data : []
        if (this.modoEdicion && this.becaEditId) {
          lista = lista.filter(f => Number(f.id) !== Number(this.becaEditId))
        }
        this.alertaFamiliares = lista
      } catch (e) {
        this.alertaFamiliares = []
      }
    },

    async cargarSugeridoEmpleado(idTrabajador) {
      try {
        const { data } = await this.$http.get('becas.trabajador.alumno.sugerido/' + idTrabajador)
        const rows = Array.isArray(data) ? data : []
        this.sugeridosEmpleado = rows.map(r => ({
          id_alumno: r.id_alumno,
          matricula: r.matricula,
          alumno: r.alumno,
          etiqueta: (r.matricula || '') + ' — ' + (r.alumno || '')
        }))

        if (!this.sugeridosEmpleado.length) {
          this.sinMatriculaEmpleado = true
          if (!this.modoEdicion || !this.form.id_alumno) {
            this.alumnoSeleccionado = null
            this.form.id_alumno = null
            this.form.matricula = null
          }
          return
        }

        this.sinMatriculaEmpleado = false
        this.alumnosBusqueda = this.sugeridosEmpleado.slice()
        if (!this.form.id_alumno) {
          this.seleccionarAlumno(this.sugeridosEmpleado[0])
          return
        }

        const idSel = Number(this.form.id_alumno)
        const match = this.sugeridosEmpleado.find((s) => Number(s.id_alumno) === idSel)
        if (match) {
          this.seleccionarAlumno(match, true)
        } else if (!this.form.esFamiliar) {
          this.alumnoSeleccionado = null
          this.form.id_alumno = null
          this.form.matricula = null
          this.seleccionarAlumno(this.sugeridosEmpleado[0])
        }
      } catch (e) {
        this.sinMatriculaEmpleado = true
        await this.cargarFamiliaresVinculados(idTrabajador)
        this.validarError(this.msgHttp(e, 'Error al consultar matrícula del trabajador'))
      }
    },

    async cargarFamiliaresVinculados(idTrabajador) {
      if (!idTrabajador) {
        this.alumnosFamiliaresVinculados = []
        return
      }
      try {
        const { data } = await this.$http.get(
          'becas.trabajador.alumnos.familiares/' + idTrabajador,
          { params: { vigente: 0 } }
        )
        const rows = Array.isArray(data) ? data : []
        this.alumnosFamiliaresVinculados = rows.map((r) => this.normalizarAlumnoItem(r))
      } catch (e) {
        this.alumnosFamiliaresVinculados = []
      }
    },

    async cargarFamiliaresParaSelect() {
      if (!this.form.id_trabajador || !this.form.esFamiliar) {
        this.familiaresMatriculaVigente = []
        this.sinFamiliaresVigentes = false
        return
      }

      this.loadingAlumnos = true
      try {
        const { data } = await this.$http.get(
          'becas.trabajador.alumnos.familiares/' + this.form.id_trabajador,
          { params: { vigente: 1 } }
        )
        const rows = Array.isArray(data) ? data : []
        let lista = rows.map((r) => this.normalizarAlumnoItem(r))
        this.sinFamiliaresVigentes = lista.length === 0

        if (this.alumnoSeleccionado && this.alumnoSeleccionado.id_alumno) {
          const idSel = Number(this.alumnoSeleccionado.id_alumno)
          const match = lista.find((m) => Number(m.id_alumno) === idSel)
          if (!match) {
            lista = this.incluirAlumnoEnLista(lista, this.alumnoSeleccionado)
          }
        }

        this.familiaresMatriculaVigente = lista

        if (lista.length === 1 && !this.form.id_alumno) {
          this.seleccionarAlumno(lista[0])
          return
        }

        if (this.form.id_alumno) {
          const idSel = Number(this.form.id_alumno)
          const match = lista.find((m) => Number(m.id_alumno) === idSel)
          if (match) {
            this.seleccionarAlumno(match, true)
          }
        }
      } catch (e) {
        this.familiaresMatriculaVigente = []
        this.sinFamiliaresVigentes = true
        this.validarError(this.msgHttp(e, 'Error al cargar familiares del trabajador'))
      } finally {
        this.loadingAlumnos = false
      }
    },

    normalizarAlumnoItem(r) {
      const alumno = r.alumno || (
        (r.nombre || r.alumno_nombre || '') + ' ' + (r.apellido_paterno || '') + ' ' + (r.apellido_materno || '')
      ).trim()
      const vigente = Number(r.alumno_activo) === 1 && Number(r.grupos_activos) > 0
      return {
        id_alumno: r.id_alumno,
        matricula: r.matricula,
        alumno: alumno,
        edad: r.edad != null && r.edad !== '' ? r.edad : null,
        etiqueta: (r.matricula || '') + ' — ' + alumno,
        vigente: vigente
      }
    },

    aplicarDatosDesdeAlumno(item) {
      if (!item || !this.form.esFamiliar) return
      if (item.alumno) {
        this.form.nombre = item.alumno
      }
      if (item.edad != null && item.edad !== '') {
        this.form.edad = item.edad
      }
    },

    seleccionarAlumno(item, silencioso) {
      if (!item) return
      this.alumnoSeleccionado = item
      this.alumnosBusqueda = this.incluirAlumnoEnLista(this.alumnosBusqueda, item)
    },

    incluirAlumnoEnLista(lista, alumno) {
      if (!alumno || !alumno.id_alumno) return Array.isArray(lista) ? lista.slice() : []
      const base = Array.isArray(lista) ? lista.slice() : []
      const id = Number(alumno.id_alumno)
      const idx = base.findIndex((a) => Number(a.id_alumno) === id)
      if (idx >= 0) {
        base[idx] = alumno
        return base
      }
      return [alumno].concat(base)
    },

    validarFormulario() {
      if (!this.form.id_trabajador) {
        this.validarError('Selecciona un trabajador')
        return false
      }
      if (this.form.esFamiliar) {
        if (!this.form.nombre || !this.form.parentesco) {
          this.validarError('Nombre y parentesco del familiar son requeridos')
          return false
        }
      }
      return true
    },

    async guardar() {
      if (!this.validarFormulario()) return

      this.guardando = true
      try {
        const formData = new FormData()
        Object.keys(this.form).forEach(key => {
          let value = this.form[key]
          if (typeof value === 'boolean') {
            value = value ? 1 : 0
          }
          if (key === 'archivo') {
            if (value) formData.append(key, value)
          } else {
            formData.append(key, value != null ? value : '')
          }
        })

        if (this.modoEdicion && this.becaEditId) {
          await this.$http.put('becas.trabajador.update/' + this.becaEditId, formData)
          this.validarSuccess('Beca actualizada correctamente')
        } else {
          const res = await this.$http.post('becas.trabajador.add', formData)
          const folio = res.body && res.body.folio_rh
          this.validarSuccess(
            folio
              ? 'Beca registrada. Folio RH: ' + folio
              : 'Beca registrada correctamente'
          )
        }

        this.cerrarModal()
        this.getBecas()
      } catch (err) {
        this.validarError(this.msgHttp(err, 'Error al guardar la beca'))
      } finally {
        this.guardando = false
      }
    },

    resetForm() {
      this.form = this.formVacio()
      this.tipoBeneficiario = 'empleado'
      this.alumnoSeleccionado = null
      this.alumnosBusqueda = []
      this.alertaFamiliares = []
      this.sinMatriculaEmpleado = false
      this.sugeridosEmpleado = []
      this.alumnosFamiliaresVinculados = []
      this.familiaresMatriculaVigente = []
      this.sinFamiliaresVigentes = false
      this.modoEdicion = false
      this.becaEditId = null
    },

    abrirFamiliar(item) {
      this.archivoPreview = item.acta_nacimiento
        ? ('http://localhost:3004/actas-nacimiento/' + item.acta_nacimiento)
        : null
      this.familiar = item
      this.dialogFamiliar = true
    },

    getExtension(nombre) {
      if (!nombre) return 'N/A'
      return nombre.split('.').pop().toUpperCase()
    },

    rowKeyBeca(item) {
      if (item.id) return 'rh-' + item.id
      return 'ins-' + item.id_trabajador + '-' + item.id_alumno
    },

    esFamiliarInscripciones(item) {
      if (!item) return false
      if (item.es_familiar_inscripciones != null && item.es_familiar_inscripciones !== '') {
        return Number(item.es_familiar_inscripciones) === 1
      }
      return Number(item.esFamiliar) === 1
    },

    formatearFecha(fecha) {
      if (!fecha) return ''
      return String(fecha).substr(0, 10)
    },

    async abrirSolicitudDesdeVinculo(item) {
      this.modoEdicion = false
      this.becaEditId = null
      this.resetForm()
      const esFam = this.esFamiliarInscripciones(item)
      this.tipoBeneficiario = esFam ? 'familiar' : 'empleado'
      this.form.esFamiliar = esFam
      this.form.id_trabajador = item.id_trabajador
      this.dialog = true
      await this.onCambioTrabajador()
      if (item.id_alumno) {
        const alumnoObj = this.normalizarAlumnoItem({
          id_alumno: item.id_alumno,
          matricula: item.matricula,
          alumno: item.alumno || item.nombre,
          edad: item.edad,
          alumno_activo: item.matricula_vigente_sn,
          grupos_activos: item.matricula_vigente_sn
        })
        this.seleccionarAlumno(alumnoObj, true)
      }
    },

    getColorEstado(e) {
      if (e == 0) return 'orange'
      if (e == 1) return 'green'
      if (e == 2) return 'red'
      return 'grey'
    },

    getTextoEstado(e) {
      if (e == 0) return 'Pendiente'
      if (e == 1) return 'Aprobado'
      if (e == 2) return 'Rechazado'
      return '—'
    },

    abrirEstado(item) {
      this.becaSeleccionada = item
      this.estadoSeleccionado = item.estado
      this.motivoRechazo = item.motivo_rechazo
      this.dialogEstado = true
    },

    async guardarEstado() {
      if (this.estadoSeleccionado == 2 && !this.motivoRechazo) {
        return this.validarError('Debes escribir un motivo')
      }

      try {
        await this.$http.put(
          'becas.trabajador.estado/' + this.becaSeleccionada.id,
          {
            estado: this.estadoSeleccionado,
            motivo_rechazo: this.motivoRechazo
          }
        )
        this.dialogEstado = false
        this.getBecas()
        this.validarSuccess('Estado actualizado')
      } catch (err) {
        this.validarError(this.msgHttp(err, 'Error al actualizar el estado'))
      }
    },

    msgHttp(error, fallback) {
      if (error && error.response && error.response.data) {
        if (typeof error.response.data === 'string') return error.response.data
        if (error.response.data.message) return error.response.data.message
      }
      return fallback
    }
  }
}
</script>

<style scoped>
.line-height-tight {
  line-height: 1.35;
}

.becas-filtros-titulo {
  min-height: auto;
  line-height: 1.4;
}

.becas-filtros-ayuda {
  line-height: 1.5;
  max-width: 42rem;
}

.becas-filtros-campos >>> .v-input {
  margin-top: 0;
}
</style>
